import type { Catalog } from "../../en";

/** Filipino: Knowledge gaps screen (mirrors en/engage/gaps.ts). */
export const gaps: Catalog["engage"]["gaps"] = {
  title: "Mga knowledge gap",
  subtitle: "Mga tanong na hindi nasagot nang maayos ng assistant, pinagsama ayon sa kahulugan. Sagutin nang isang beses at sakop na ang lahat ng katulad na tanong.",
  agentFilter: "Agent",
  export: "I-export",
  exported: "Na-export ang gap report · {{file}}",
  uploadDocument: "Mag-upload ng dokumento",
  uploadNewer: "Mag-upload ng mas bagong bersyon",
  openOutdated: "Buksan ang lumang source",
  stats: {
    open: "Bukas na gap",
    questionsAffected_one: "{{count}} tanong ang apektado",
    questionsAffected_other: "{{count}} tanong ang apektado",
    resolvedMonth: "Naresolba ngayong buwan",
    vsLastMonth: "{{delta}} kumpara noong nakaraang buwan",
    coverage: "Saklaw ng sagot",
    coverageNone: "Wala pang sagot",
    topCategory: "Pangunahing kategorya ng gap",
    topCategoryNone: "Wala pa",
    topCategoryHint: "Pinakamadalas itanong sa mga bukas na gap",
  },
  tabs: {
    label: "Mga view ng gap",
    unanswered: "Hindi nasagot",
    lowConfidence: "Mababang kumpiyansa",
    negative: "Negatibong feedback",
    resolved: "Naresolba",
  },
  search: "Maghanap ng tanong…",
  sort: {
    label: "Ayusin",
    most_asked: "Pinakamadalas itanong",
    most_recent: "Pinakabago",
    oldest: "Pinakaluma muna",
  },
  columns: {
    cluster: "Grupo ng tanong",
    asked: "Itinanong",
    reason: "Dahilan",
    actions: "Mga aksyon",
  },
  selectAll: "Piliin lahat",
  selectRow: "Piliin ang {{label}}",
  bulk: {
    selected_one: "{{count}} ang napili",
    selected_other: "{{count}} ang napili",
    assignTo: "Italaga kay",
    ignore: "Huwag pansinin",
    clear: "I-clear ang pinili",
    assigned_one: "{{count}} gap ang naitalaga kay {{name}}",
    assigned_other: "{{count}} gap ang naitalaga kay {{name}}",
    ignored_one: "{{count}} grupo ang hindi na papansinin",
    ignored_other: "{{count}} grupo ang hindi na papansinin",
  },
  reason: {
    no_source: "Walang nakitang source",
    outdated: "Lumang source",
    low_confidence: "Mababang kumpiyansa",
    thumbs_down: "Thumbs down",
    resolved: "Naresolba",
  },
  asks_one: "tanong",
  asks_other: "tanong",
  trendLabel: "Mga tanong bawat araw, nakaraang 7 araw",
  moreQuestions: "+{{count}} pa",
  firstLast: "Una {{first}} · Huli {{last}}",
  avgConfidence: "Average na kumpiyansa {{value}}",
  feedbackQuote: "Feedback ng bisita",
  writeAnswer: "Sumulat ng sagot",
  more: "Iba pang aksyon para sa {{label}}",
  assignHeading: "Italaga kay",
  assignedTo: "Nakatalaga kay {{name}}",
  assigned: "Naitalaga kay {{name}} · makakatanggap sila ng email",
  unassign: "Alisin ang pagtatalaga",
  unassigned: "Inalis ang pagtatalaga",
  ignoreMenu: "Huwag pansinin…",
  resolvedBy: "Naresolba {{date}} · Q&A source",
  resolvedNoSource: "Naresolba {{date}}",
  viewSource: "Tingnan ang source",
  showingResolved: "Ipinapakita ang {{shown}} naresolbang gap",
  empty: {
    openTitle: "Walang gap sa view na ito",
    openBody: "Maayos na sinasagot ng assistant ang mga tanong na ito. Lalabas dito ang mga bagong gap habang nagtatanong ang mga bisita.",
    searchTitle: "Walang tumugmang tanong",
    searchBody: "Subukan ang ibang paghahanap o i-clear ito para makita ang lahat ng bukas na gap.",
    clearSearch: "I-clear ang paghahanap",
    resolvedTitle: "Wala pang naresolba",
    resolvedBody: "Dito lilipat ang mga gap na sinagot mo o sinaklaw ng dokumento.",
  },
  loadError: "Hindi ma-load ang mga knowledge gap.",
  statsError: "Hindi ma-load ang stats.",
  footnote: "Awtomatikong pinagsasama ang mga tanong ayon sa semantic similarity (magkakatugma ang English, Filipino at Taglish). Nagsasara ang gap kapag nasagot ng assistant ang grupo nang may ≥ 80% kumpiyansa.",
  sheet: {
    eyebrow: "Sumulat ng sagot",
    questions: "Mga tanong sa grupong ito",
    viewChat: "Buksan ang usapan",
    answer: "Sagot",
    answerPlaceholder: "Isulat ang opisyal na sagot. Ipapahayag ito ng assistant nang natural at sasagot sa wika ng bisita.",
    answerTip: "Tip: isama ang halaga, petsa at kung sino ang kokontakin. Taglish na sagot ang ibibigay sa mga tanong na Taglish.",
    answerRequired: "Sumulat o mag-suggest muna ng sagot",
    suggest: "Mag-suggest gamit ang AI",
    suggested_one: "Draft batay sa {{count}} source. Pakisuri ang mga detalye.",
    suggested_other: "Draft batay sa {{count}} source. Pakisuri ang mga detalye.",
    noSuggestion: "Wala pang source na sumasaklaw dito — ikaw na ang sumulat ng sagot.",
    access: "Sino ang makakakita ng sagot na ito",
    expires: "Mag-e-expire",
    expiry: {
      never: "Hindi kailanman",
      days30: "Sa loob ng 30 araw",
      days90: "Sa loob ng 90 araw",
      custom: "Pumili ng petsa…",
    },
    customDate: "Petsa ng expiry",
    customDateRequired: "Pumili ng petsa sa hinaharap",
    agents: "Mga agent na gagamit ng sagot",
    agentsRequired: "Pumili ng kahit isang agent",
    uploadInstead: "Mag-upload na lang ng dokumento",
    save: "I-save bilang Q&A source",
    saved: "Na-save bilang Q&A source · {{audience}} · live na",
    loadError: "Hindi ma-load ang grupong ito.",
  },
  ignore: {
    title: "Huwag pansinin ang gap na ito?",
    body: "Hindi na lalabas dito ang mga grupong hindi pinapansin. Patuloy na gagamitin ng assistant ang fallback na sagot nito sa mga tanong na ito.",
    reasonLabel: "Dahilan",
    out_of_scope: "Labas sa saklaw ng workspace na ito",
    spam: "Spam / test na mensahe",
    always_staff: "Dapat laging sa staff (sensitibo)",
    other: "Iba pa",
    confirm: "Huwag pansinin ang grupo",
    done: "Hindi na papansinin ang grupo",
  },
};
